var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"name"},[_c('div',{staticClass:"name-text"},[_c('core-gamename',{staticClass:"name-text-link",attrs:{"game":_vm.item.game,"id":_vm.item.id}}),_c('com-tags',{attrs:{"item":_vm.item}})],1),_c('core-date',{staticClass:"name-date",attrs:{"date":_vm.item.play.date}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }